import * as React from 'react';
import usePlayground from '@/modules/playground/hooks/usePlayground.hook';
import usePageUnload from '@/core/hooks/usePageUnload.hook';
import MainLayout from '../main-layout';

type PlaygroundLayoutProps = {
  children: React.ReactNode;
};

const PlaygroundLayout = ({ children }: PlaygroundLayoutProps) => {
  const { state } = usePlayground();
  usePageUnload(state.actions.length > 0);

  return (
    <MainLayout className="items-center" childrenClassName="max-w-playground">
      {children}
    </MainLayout>
  );
};

export default PlaygroundLayout;
